export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9819.3049c7f3.jpg";